"use client";
import React, { useState, useEffect } from "react";

import CourseCard from "./../components/courses/CourseCard";
import { fetchMyCourse } from "./../api/courseApi";
import AccountLayout from "../layout/AccountLayout";
import ToastService from "../services/ToastService";
import Loading from "../components/common/Loading";
import { useSelector } from "react-redux";

const MyCoursePage = () => {
  const user = useSelector((state) => state.user.user);
  const [data, setData] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const fetchData = async () => {
    try {
      const data = await fetchMyCourse({ userId: user && user.guid });

      if (data) {
        setData(data);
        setLoading(false);
      }
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        ToastService.Error(error.message);
        return;
      }
      console.log(error);
      ToastService.Error(error.response.data.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <AccountLayout>


        {
          data && data.isAllCourse && <h2>You can access all courses any time!</h2>}
        <h2>Bought courses</h2>
        <section className="all-challenges js-all-challenges">

          <div className="items">
            {isLoading ? (
              <Loading />
            ) : (
              data &&
              data.courses.map((item, index) => {
                return <CourseCard key={index} row={index} item={item} />;
              })
            )}
          </div>
        </section>
      </AccountLayout>
    </>
  );
};

export default MyCoursePage;
